export var LoginType;
(function (LoginType) {
    LoginType["None"] = "None";
    LoginType["BankId"] = "BankId";
    LoginType["VerificationCode"] = "VerificationCode";
    LoginType["Password"] = "Password";
    LoginType["SSO"] = "SSO";
})(LoginType || (LoginType = {}));
